export const getRowsToDisplay = (params) => {
    let rowsToDisplay = [];
    params.api?.forEachNodeAfterFilterAndSort((node) => rowsToDisplay.push(node));
    return rowsToDisplay;
};